/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import 'react-dates/initialize';
import { DateRangePicker, FocusedInputShape } from 'react-dates';
import moment from 'moment';
import CurrencyInput from 'react-currency-input-field';
import 'react-dates/lib/css/_datepicker.css';
import Switch from 'components/atoms/switch_contratos';
import { PoderesOption, PoderesOptions } from 'services/poderes';
import { States } from 'services/states';
import { esferasOption, esferasOptions } from 'services/esferas_contracts';
import { getCitiesByStates } from 'services/actions/cities_actions';
import { Modalities } from 'services/modalities';
import { TipoContratoOption, TipoContratoOptions } from 'services/tipo_contrato';
import Select from 'react-select';
import { CitiesTypes, StatesTypes, ModalitiesTypes } from 'store/modules/online_search_store/types';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { getContract, SearchContracts } from 'store/modules/contracts_store/actions';
import companyId from 'services/company_id';
import tabId from 'services/tabId';
import { PanelState } from 'store/modules/panel_store/types';
import { Container } from './styles';

interface ContractsSearchFormProps {
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
}

interface IHandleDatesChange {
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
}

const ContractsSearchForm = (props: ContractsSearchFormProps) => {
  const { page, setPage } = props;
  const dispatch = useDispatch();

  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);

  const [search, setSearch] = useState<boolean>(false);
  const [searchBarOpened, setSearchBarOpened] = useState<boolean>(true);
  const [searchAll, setSelectedAll] = useState<boolean>(true);
  const [selectedPoder, setSelectedPoder] = useState<Array<PoderesOption>>([]);
  const [selectedObjeto, setSelectedObjeto] = useState('');
  const [selectedOrgao, setSelectedOrgao] = useState('');
  const [selectedEmpresa, setSelectedEmpresa] = useState('');
  const [selectedIdCNL, setSelectedIdCNL] = useState('');
  const [selectedEdital, setSelectedEdital] = useState('');
  const [statesList, setStatesList] = useState<Array<StatesTypes>>([]);
  const [citiesList, setCitiesList] = useState<Array<CitiesTypes>>([]);
  const [cities, setCities] = useState<Array<CitiesTypes>>([]);
  const [modalitiesList, setModalitiesList] = useState<Array<ModalitiesTypes>>([]);
  const [modalidade, setModalidade] = useState<Array<ModalitiesTypes>>([]);
  const [selectedEsfera, setSelectedEsfera] = useState<Array<esferasOption>>([]);
  const [selectedTipoContrato, setSelectedTipoContrato] = useState<Array<TipoContratoOption>>([]);
  const [startDate, setStartDate] = useState<moment.Moment | null>(null);
  const [endDate, setEndDate] = useState<moment.Moment | null>(null);
  const [focusedInput, setFocusedInput] = useState<FocusedInputShape | null>(null);
  const [cnpj, setCnpj] = useState('');
  const [valorEstimado, setValorEstimado] = React.useState<number | null>(null);
  const [valorEstimadoAte, setValorEstimadoAte] = React.useState<number | null>(null);
  const [valorContratado, setValorContratado] = React.useState<number | null>(null);
  const [valorContratadoAte, setValorContratadoAte] = React.useState<number | null>(null);

  const handleDatesChange = ({ startDate, endDate }: IHandleDatesChange) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const onToggle = () => setSelectedAll(!searchAll);

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const poderes = selectedPoder?.map((selectedPoder) => selectedPoder.value);
  const esfera = selectedEsfera?.map((selectedEsfera) => selectedEsfera.value);
  const tipo_contrato = selectedTipoContrato?.map(
    (selectedTipoContrato) => selectedTipoContrato.value,
  );
  const state = statesList?.map((statesList) => statesList.value);
  const Getcities = cities?.map((cities) => cities.value);
  const modalidadeSelecionada = modalidade?.map((modalidade) => modalidade.value);

  useEffect(() => {
    document.title = 'Contratos - ConLicitação';
    setModalitiesList(
      Modalities?.map((modalidade) => {
        return { label: `${modalidade.sigla} - ${modalidade.nome}`, value: modalidade.id };
      }),
    );
  }, []);

  const handleClick = async () => {
    setSearch(true);
    setPage(1);
    const params = {
      tipo_orgao_id: esfera,
      tipo_contrato_id: tipo_contrato,
      objeto: selectedObjeto,
      id: selectedIdCNL,
      edital: selectedEdital,
      empresa: selectedEmpresa,
      exact_search: searchBarOpened,
      all_segments: searchAll,
      vigencia_inicio: startDate ? startDate.format('YYYY-MM-DD') : null,
      vigencia_fim: endDate ? endDate.format('YYYY-MM-DD') : null,
      state,
      Getcities,
      poderes,
      cnpj,
      modalidadeSelecionada,
      valorEstimado,
      valorEstimadoAte,
      valorContratado,
      valorContratadoAte,
      searchAll,
      orgao: selectedOrgao,
      companyId: companyId(profile),
    };
    dispatch(SearchContracts(params, 1));
  };

  useEffect(() => {
    const params = {
      tipo_orgao_id: esfera,
      tipo_contrato_id: tipo_contrato,
      objeto: selectedObjeto,
      id: selectedIdCNL,
      edital: selectedEdital,
      empresa: selectedEmpresa,
      exact_search: searchBarOpened,
      all_segments: searchAll,
      vigencia_inicio: startDate ? startDate.format('YYYY-MM-DD') : null,
      vigencia_fim: endDate ? endDate.format('YYYY-MM-DD') : null,
      state,
      Getcities,
      poderes,
      cnpj,
      modalidadeSelecionada,
      valorEstimado,
      valorEstimadoAte,
      valorContratado,
      valorContratadoAte,
      searchAll,
      orgao: selectedOrgao,
      companyId: companyId(profile),
    };
    dispatch(SearchContracts(params, page));
  }, [page, search, profile.currentCompany[tabId()]]);

  useEffect(() => {
    (async () => {
      const statesIds = statesList?.map((state: { value: number }) => state.value);
      if (statesIds?.length > 0) {
        const citiesResponse = await getCitiesByStates(statesIds);
        setCitiesList(
          citiesResponse?.map((city: any) => {
            return { label: `${city.name_sub} - ${city.acronym}`, value: city.id };
          }),
        );
      }
      if (statesIds?.length === 0) setCitiesList([]);
    })();
  }, [statesList]);

  const handleReset = async () => {
    dispatch(
      getContract({
        page: 1,
      }),
    );
    setSelectedObjeto('');
    setSelectedPoder([]);
    setStartDate(null);
    setEndDate(null);
    setSelectedEmpresa('');
    setSelectedEdital('');
    setSelectedIdCNL('');
    setCnpj('');
    setModalidade([]);
    setCities([]);
    setStatesList([]);
    setValorEstimado(null);
    setValorEstimadoAte(null);
    setValorContratado(null);
    setValorContratadoAte(null);
    setSelectedAll(true);
    setSelectedOrgao('');
    setSelectedEsfera([]);
    setSelectedTipoContrato([]);
  };

  return (
    <Container>
      <div className="row">
        <div
          className={`col-12 col-lg-3 col-md-12 pr-2 filter-bar shadow ${
            profile.in_sample || panel?.registration_type_validation === 1 ? 'hasTopBanner' : ''
          }`}
        >
          <div className="filter-form pr-2">
            <div className="row d-print-none">
              <div className="col-md-12">
                <div className="row mb-3">
                  <div className="col-md-12 pr-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-link float-right"
                      onClick={handleReset}
                    >
                      Limpar
                    </button>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="objetoSearch" className="m-0">
                      Objeto
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="objetoSearch"
                      placeholder="Pesquise por Objeto"
                      value={selectedObjeto}
                      onChange={(e) => setSelectedObjeto(e.target.value)}
                    />
                  </div>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="exact_search"
                    onChange={(e) => setSearchBarOpened(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="exact_search">
                    Busca Exata
                  </label>
                </div>
                <div>
                  <Switch handleChange={() => onToggle()} checked={searchAll} />
                </div>
                <hr />
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="objetoSearch" className="m-0">
                      Órgão
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="objetoSearch"
                      placeholder="Pesquise por Órgão"
                      value={selectedOrgao}
                      onChange={(e) => setSelectedOrgao(e.target.value)}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <label htmlFor="stateSearch" className="m-0">
                      Estado
                    </label>
                    <Select
                      name="StateSearch"
                      isMulti
                      value={statesList || ''}
                      closeMenuOnSelect={false}
                      onChange={(event) => setStatesList([...event])}
                      options={States}
                      placeholder="Selecione os Estados"
                      className="basic-multi-select"
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-between col-md-12 p-0 mb-3">
                  <div className="float-right date-template">
                    <button
                      type="button"
                      className="btn btn-sm btn-link pr-0"
                      onClick={() => setStatesList(States)}
                    >
                      Todos os Estados
                    </button>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="citySearch" className="m-0">
                      Cidade
                    </label>
                    <Select
                      name="CitySearch"
                      isMulti
                      closeMenuOnSelect={false}
                      value={cities || ''}
                      onChange={(event) => setCities([...event])}
                      options={citiesList}
                      noOptionsMessage={() => 'Selecione um estado'}
                      placeholder="Selecione as Cidades"
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="editalSearch" className="m-0">
                      Nº Edital
                    </label>
                    <input
                      type="text"
                      id="editalSearch"
                      className="form-control"
                      placeholder="Pesquise por Nº Edital"
                      value={selectedEdital}
                      onChange={(e) => setSelectedEdital(e.target.value)}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <label htmlFor="modalitiesSearch" className="m-0">
                      Modalidades
                    </label>
                    <Select
                      name="modalitiesSearch"
                      isMulti
                      value={modalidade || ''}
                      closeMenuOnSelect={false}
                      onChange={(event) => setModalidade([...event])}
                      options={modalitiesList}
                      placeholder="Selecione as Modalidades"
                      className="basic-multi-select"
                    />
                    <div className="float-right date-template">
                      <button
                        type="button"
                        className="btn btn-sm btn-link"
                        onClick={() => setModalidade(modalitiesList)}
                      >
                        Todas as Modalidades
                      </button>
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="idSearch" className="m-0">
                      Nº Conlicitação
                    </label>
                    <input
                      type="text"
                      id="idSearch"
                      className="form-control"
                      placeholder="Pesquise por Nº Conlicitação"
                      value={selectedIdCNL}
                      onChange={(e) => setSelectedIdCNL(e.target.value)}
                    />
                  </div>
                </div>
                <hr />
                <div className="row mb-3">
                  <div className="col-md-12">
                    <div>
                      <label htmlFor="vigencia" className="m-0">
                        Vigência
                      </label>
                    </div>
                    <DateRangePicker
                      disabled={false}
                      startDate={startDate}
                      startDateId="daterangepicker_start_date"
                      endDate={endDate}
                      endDateId="daterangepicker_end_date"
                      onDatesChange={handleDatesChange}
                      focusedInput={focusedInput}
                      onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
                      startDatePlaceholderText="De"
                      endDatePlaceholderText="Até"
                      hideKeyboardShortcutsPanel
                      displayFormat="DD/MM/YYYY"
                      isOutsideRange={() => false}
                      showClearDates
                      small
                      numberOfMonths={1}
                    />
                  </div>
                </div>
                <hr />
                <div className="row mb-3">
                  <div className="col-md-12">
                    <div>
                      <label htmlFor="codigoOrgaoSearch" className="m-0">
                        Valor Estimado
                      </label>
                    </div>
                    <div className="row">
                      <div className="col-md-6 mb-md-0 mb-2">
                        <CurrencyInput
                          value={valorEstimado ?? undefined}
                          prefix="R$"
                          placeholder="De"
                          id="valor-estimado-de"
                          name="valor-estimado-de"
                          className="form-control input-sm"
                          decimalsLimit={2}
                          onValueChange={(_, __, values) => setValorEstimado(values?.float ?? null)}
                        />
                      </div>
                      <div className="col-md-6">
                        <CurrencyInput
                          value={valorEstimadoAte ?? undefined}
                          prefix="R$"
                          placeholder="Até"
                          id="valor-estimado-ate"
                          name="valor-estimado-ate"
                          className="form-control input-sm"
                          decimalsLimit={2}
                          onValueChange={(_, __, values) =>
                            setValorEstimadoAte(values?.float ?? null)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <div>
                      <label htmlFor="codigoOrgaoSearch" className="m-0">
                        Valor Contratado
                      </label>
                    </div>
                    <div className="row">
                      <div className="col-md-6 mb-md-0 mb-2">
                        <CurrencyInput
                          value={valorContratado ?? undefined}
                          prefix="R$"
                          placeholder="De"
                          id="valor-contratado-de"
                          name="valor-contratado-de"
                          className="form-control input-sm"
                          decimalsLimit={2}
                          onValueChange={(_, __, values) =>
                            setValorContratado(values?.float ?? null)
                          }
                        />
                      </div>
                      <div className="col-md-6">
                        <CurrencyInput
                          value={valorContratadoAte ?? undefined}
                          prefix="R$"
                          placeholder="Até"
                          id="valor-contratado-ate"
                          name="valor-contratado-ate"
                          className="form-control input-sm"
                          decimalsLimit={2}
                          onValueChange={(_, __, values) =>
                            setValorContratadoAte(values?.float ?? null)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="codigoOrgaoSearch" className="m-0">
                      Empresa
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="codigoOrgaoSearch"
                      placeholder="Pesquise por Empresa"
                      value={selectedEmpresa}
                      onChange={(e) => setSelectedEmpresa(e.target.value)}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="codigoOrgaoSearch" className="m-0">
                      CNPJ Fornecedor
                    </label>
                    <input
                      className="form-control"
                      value={cnpj}
                      onChange={(e) => setCnpj(e.target.value)}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label className="m-0">Esfera</label>
                    <Select
                      isMulti
                      name="esferas"
                      options={esferasOptions}
                      value={selectedEsfera}
                      placeholder="Selecione as Esferas"
                      classNamePrefix="select"
                      className="basic-multi-select"
                      onChange={(event) => setSelectedEsfera([...event])}
                    />
                  </div>
                </div>
                <hr />
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label className="m-0">Tipos de contrato</label>
                    <Select
                      isMulti
                      name="TipoContratoSearch"
                      options={TipoContratoOptions}
                      value={selectedTipoContrato}
                      placeholder="Selecione as Esferas"
                      classNamePrefix="select"
                      className="basic-multi-select"
                      onChange={(event) => setSelectedTipoContrato([...event])}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label className="m-0">Poderes</label>
                    <Select
                      isMulti
                      name="PoderesSearch"
                      options={PoderesOptions}
                      value={selectedPoder}
                      placeholder="Selecione as Esferas"
                      classNamePrefix="select"
                      className="basic-multi-select"
                      onChange={(event) => setSelectedPoder([...event])}
                    />
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3 px-2 py-3 filter-button d-print-none">
            <button type="button" className="btn btn-primary w-100" onClick={() => handleClick()}>
              Pesquisar
            </button>
          </div>
        </div>
      </div>
    </Container>
  );
};
export default ContractsSearchForm;
